import { Navigate, useLocation } from "react-router-dom";
import { SideBar } from "./SideBar";
import DeviceIcon from "../../assets/images/vectors/SideBarIcons/DeviceIcon";
import DeviceLogIcon from "../../assets/images/vectors/SideBarIcons/DeviceLogIcon";
import OrderIcon from "../../assets/images/vectors/SideBarIcons/OrderIcon";
import LicenseIcon from "../../assets/images/vectors/SideBarIcons/LicenseIcon";
import AccountIcon from "../../assets/images/vectors/SideBarIcons/AccountIcon";
import DealerIcon from "../../assets/images/vectors/SideBarIcons/DealerIcon";
import OemIcon from "../../assets/images/vectors/SideBarIcons/OemIcon";
import OemInfoIcon from "../../assets/images/vectors/SideBarIcons/OemInfoIcon";
import PaymentIcon from "../../assets/images/vectors/SideBarIcons/PaymentIcon";
import CustomerIcon from "../../assets/images/vectors/SideBarIcons/CustomerIcon";
import { allProtectedRouteList } from "../constants/protectedRoute";
import { SipIcon } from "../../assets/images/vectors/SideBarIcons/SipIcon";
import PSIcon from "../../assets/images/vectors/SideBarIcons/PSIcon";
import {
  FaAddressCard,
  FaFileInvoiceDollar,
  FaMicrochip,
  FaUserTag,
} from "react-icons/fa6";
import {
  RiAlignItemBottomFill,
  RiFileList3Fill,
  RiQrCodeFill,
  RiTimeFill,
} from "react-icons/ri";
import { LinkOutlined } from "@ant-design/icons";
import { getEnageUser } from "../hooks/getUserRole";
import { useAuthData } from "../../providers/AuthProvider";
import { Spinner } from "./Spinner";

//SideBar items for System Admin & System Manager role
const systemAdminSiderbarItems = [
  {
    label: "Site",
    key: "/site",
    icon: <FaUserTag style={{ fontSize: "20px" }} />,
  },
  // {
  //   label: "Site",
  //   key: "/site",
  //   icon: <FaGlobe style={{ fontSize: "20px" }} />,
  // },
  {
    label: "Device",
    key: "/device",
    icon: <DeviceIcon />,
  },
  {
    label: "Device Log",
    key: "/devicelog",
    icon: <DeviceLogIcon />,
  },
  {
    label: "Order",
    key: "/order",
    icon: <OrderIcon />,
  },
  {
    label: "Purchase",
    key: "/purchase",
    icon: <FaFileInvoiceDollar style={{ fontSize: "18px" }} />,
  },
  {
    label: "Payment",
    key: "/payment",
    icon: <PaymentIcon style={{ fontSize: "18px" }} />,
  },
  {
    label: "V1 RMC",
    key: "/v1-rmc",
    icon: <LinkOutlined style={{ fontSize: "18px" }} />,
  },
  {
    label: "Virtual QR/NFC",
    key: "/virtual-qr",
    icon: <RiQrCodeFill style={{ fontSize: "18px" }} />,
  },

  {
    label: "Account",
    key: "/account",
    icon: <AccountIcon />,
  },
  {
    label: "Customer",
    key: "/customer",
    icon: <CustomerIcon />,
  },
  {
    label: "Dealer",
    key: "/dealer",
    icon: <DealerIcon />,
  },
  {
    label: "OEM",
    key: "/oem",
    icon: <OemIcon />,
  },
  {
    label: "Device Production",
    key: "/device-production",
    icon: <FaMicrochip style={{ fontSize: "18px" }} />,
  },
  {
    label: "Virtual QR/NFC Production",
    key: "/virtual-qr-production",
    icon: <RiQrCodeFill style={{ fontSize: "18px" }} />,
  },
  {
    label: "On Site Register",
    key: "/on-site-register",
    icon: <FaAddressCard style={{ fontSize: "18px" }} />,
  },
  {
    label: "Hardware",
    key: "/hardware",
    icon: <RiAlignItemBottomFill style={{ fontSize: "18px" }} />,
  },
  {
    label: "License",
    key: "/license",
    icon: <LicenseIcon />,
  },
  {
    label: "License Code",
    key: "/licensecode",
    icon: <FaAddressCard style={{ fontSize: "16px" }} />,
  },
  {
    label: "Group",
    key: "/group",
    icon: <LicenseIcon style={{ fontSize: "16px" }} />,
  },
  {
    label: "OEM Info",
    key: "/oeminfo",
    icon: <OemInfoIcon />,
  },
  {
    label: "Proxy Server",
    key: "/proxyserver",
    icon: <PSIcon />,
  },
  {
    label: "SIP",
    key: "/sip",
    icon: <SipIcon />,
  },
  {
    label: "Call History",
    key: "/call-history",
    icon: <RiTimeFill style={{ fontSize: "18px" }} />,
  },
  {
    label: "Audit Log",
    key: "/audit-log",
    icon: <RiFileList3Fill style={{ fontSize: "18px" }} />,
  },
];

//SideBar items for System User role
const systemUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Device", "Payment", "On Site Register"].includes(item?.label),
);

//SideBar items for OEM Admin & OEM Manager role
const oemAdminSidebarItems = systemAdminSiderbarItems?.filter(
  (item) =>
    ![
      "Hardware",
      "Device Production",
      "Virtual QR/NFC Production",
      // "License",
      // "License Code",
      "OEM",
      "Production",
      "OEM Info",
      "Proxy Server",
      "SIP",
      "Device Log",
      "On Site Register",
      "Order",
      "Prepurchased License",
      // "Group",
      "Call History",
      "Audit Log",
    ].includes(item?.label),
);
//SideBar items for OEM User role
const oemUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Device"]
    // "Device Log", "Invoice"]
    .includes(item?.label),
);
//SideBar items for Dealer Admin & Dealer Manager role
const dealerAdminSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  [
    "Site",
    "Device",
    // "Device Log",
    // "Order",
    "Account",
    "Customer",
    "Payment",
    "Purchase",
    "Virtual QR/NFC",
    "V1 RMC",
  ].includes(item?.label),
);
//SideBar items for Dealer User role
const dealerUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Device"]
    // "Device Log", "Invoice"].
    .includes(item?.label),
);
//SideBar items for Customer Admin & Customer Manager role
const customerAdminSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Account"].includes(item?.label),
);
//SideBar items for Customer User role
const customerUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site"].includes(item?.label),
);
//Select Sidebar based on role
export const roleSidebarMenu = {
  1: systemAdminSiderbarItems,
  2: systemAdminSiderbarItems,
  3: systemUserSidebarItems,
  4: oemAdminSidebarItems,
  5: oemAdminSidebarItems,
  6: oemUserSidebarItems,
  7: dealerAdminSidebarItems,
  8: dealerAdminSidebarItems,
  9: dealerUserSidebarItems,
  10: customerAdminSidebarItems,
  11: customerAdminSidebarItems,
  12: customerUserSidebarItems,
};
export const getUserRoles = (userData) => {
  const role = userData?.role_value;

  return {
    isSystemUser: role < 4,
    isCustomerUser: [10, 11, 12].includes(role),
    isDealerUser: [7, 8, 9].includes(role),
    isOemUser: [4, 5, 6].includes(role),
  };
};

const SETUP_ROUTE_KEYS = [
  "/device-production",
  "/virtual-qr-production",
  "/on-site-register",
  "/hardware",
  "/license",
  "/licensecode",
  "/group",
  "/oeminfo",
  "/proxyserver",
  "/call-history",
  "/audit-log",
];

/** OEM Admin / Manager only get the Setup menu when their OEM has oem_license = 1. */
export const isSetupHidden = (userData) =>
  [4, 5].includes(userData?.role_value) && Number(userData?.oem_license) !== 1;

const isSetupPath = (pathname) =>
  SETUP_ROUTE_KEYS.includes(`/${String(pathname ?? "").split("/")[1] ?? ""}`);

export const PrivateRoute = ({ children }) => {
  const { userData, authLoading } = useAuthData();
  const engageUserData = getEnageUser();
  const { pathname } = useLocation();

  if (authLoading) {
    return <Spinner />;
  }

  if (userData && isSetupHidden(userData) && isSetupPath(pathname)) {
    return <Navigate to={"/"} />;
  }

  // check current route is permitted or not
  const isPermittedRoute = allProtectedRouteList[userData?.role_value]?.some(
    (item) =>
      item?.includes("engagesite")
        ? engageUserData?.username &&
          engageUserData?.password &&
          pathname?.replace(/^\/|\/[^\/]*$/g, "").replace(/\//g, "") ===
            item.replaceAll(/[\/\d]+/g, "")
        : pathname?.replaceAll(/[\/\d]+/g, "") ===
          item?.replaceAll(/[\/\d]+/g, ""),
  );

  return userData && isPermittedRoute ? (
    <SideBar
      items={roleSidebarMenu[userData?.role_value]?.filter(
        (item) =>
          ![
            "/device-production",
            "/virtual-qr-production",
            "/on-site-register",
            "/hardware",
            // "/virtual-qr",
            "/call-history",
            "/audit-log",
            "/license",
            "/licensecode",
            "/group",
            "/oeminfo",
            "/proxyserver",
            "/sip",
          ].includes(item.key),
      )}
    >
      {children}{" "}
    </SideBar>
  ) : (
    <Navigate to={"/"} />
  );
};
